import discountEdit from './discountEdit.vue'

export default discountEdit
